export enum FieldTypes {
  TEXT = 0,
  RADIO = 1,
  CHECKBOX = 2,
  SELECT = 3,
  FILE = 4,
  MAP = 5,
  WARNINGLISTCOMPANIES = 6,
  PERPETRATOR = 7,
  REPEATER = 8,
}
